import { useMemo, useRef } from 'react';

import DraggableEnergy from '@/components/game/3d/physics/DraggableEnergy';
import PhysicsWall from '@/components/game/3d/physics/PhysicsWall';
import { getCharFromColor } from '@/util/season';

const EnergyBuilderWorldEnergyPool = ({
	worldEnergy,
	initPos,
	type = 'world-energy-pool',
}) => {
	if (worldEnergy == null || Object.keys(worldEnergy).length === 0)
		return null;

	function randomPos() {
		return Math.floor(Math.random() * 1.5) - 1.5;
	}

	const spawnedEnergies = useRef<any[]>([]);

	if (worldEnergy.length === 0) {
		spawnedEnergies.current = [];
	}

	const energyObjects = useMemo(() => {
		const energies: any[] = [];

		const energyTypes = ['red', 'green', 'blue', 'yellow', 'carbon'];

		energyTypes.forEach((color) => {
			const amount = worldEnergy[color] || 0;
			if (amount <= 0) return;

			let energyObjectType = type;
			if (color === 'carbon' || color === 'black') {
				energyObjectType = 'carbon';
			}

			for (let i = 0; i < amount; i++) {
				const energyColor = getCharFromColor(color);
				const homePosition: [number, number, number] = [
					initPos[0] + randomPos(),
					initPos[1] + 5 + i * 2,
					initPos[2] + randomPos(),
				];

				energies.push({
					id: `${type}-${color}-${i}`,
					color,
					energyColor,
					type: energyObjectType,
					homePosition,
				});
			}
		});
		return energies;
	}, [worldEnergy]);

	const energyDisplay = energyObjects.map((energyObj) => (
		<DraggableEnergy key={energyObj.id} energy={energyObj} rotato={0} />
	));

	return (
		<group key={`${type}_energy_group`}>
			{energyDisplay}
			<PhysicsWall size={[11, 1, 6]} pos={[0, 0, -5]} />
		</group>
	);
};

export default EnergyBuilderWorldEnergyPool;
